module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Briefcase-b92d609024c67d22fc4703071f01148e.svg";